export default __webpack_public_path__ + "static/media/account.07eee1a8.svg";